{
  "dismiss": "關閉"
}
